import React, { useState } from "react";
import ImageFullSize from "./ImageFullSize";

const ArtworksCard = ({ data, index }) => {
  const [openFullImageModal, setOpenFullImageModal] = useState(false);

  return (
    <>
      <ImageFullSize
        image={data?.image}
        state={openFullImageModal}
        setSate={setOpenFullImageModal}
      />

      <div
        className="flex flex-col lg:flex-row space-y-6 lg:space-y-0 lg:space-x-14 flex-none w-full snap-start"
        id={"slide" + (index + 1)}
      >
        <button
          className="flex w-full lg:max-w-[550px] lg:max-h-[450px] shrink-0 cursor-pointer"
          onClick={() => setOpenFullImageModal(true)}
        >
          <div className="flex w-full justify-center md:aspect-[4/3] max-w-full">
            <img
              src={data?.image}
              alt=""
              className="w-auto border-4 border-[#33c7b6] h-full object-contain"
            />
          </div>
        </button>

        <div className="flex flex-col space-y-5 ">
          <h1 className="text-[44px]">{data?.title}</h1>

          <p
            className="text-[24px] xl:text-[28px]"
            dangerouslySetInnerHTML={{
              __html: data?.description,
            }}
          ></p>
        </div>
      </div>
    </>
  );
};

export default ArtworksCard;
